import client from '../meetClient';

export const fetchMeetRoomData = async (roomId: string) => {
  const { data } = await client.get(`api/v1/rooms/${roomId}`);
  return data;
};
